/**
 * @generated SignedSource<<e58d2974320c6ad466f28e25b3a38f40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductComponent_StoreProduct$data = {
  readonly description: string | null;
  readonly hasExpiredExpireDates: boolean;
  readonly hasPendingExpireDateActions: boolean;
  readonly id: string;
  readonly imageUrl: string | null;
  readonly name: string | null;
  readonly numberOfPendingTodos: number;
  readonly partNumber: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductHeader_ProductDetails">;
  readonly " $fragmentType": "ProductComponent_StoreProduct";
};
export type ProductComponent_StoreProduct$key = {
  readonly " $data"?: ProductComponent_StoreProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductComponent_StoreProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductComponent_StoreProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "partNumber",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductHeader_ProductDetails"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfPendingTodos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExpiredExpireDates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPendingExpireDateActions",
      "storageKey": null
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "ad306c4b9d5e4afcf438478dc9c35193";

export default node;
